export default __webpack_public_path__ + "static/media/school.afe1e7b0.svg";